import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const root = css`
  display: table;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
`

export const tableCell = css`
  padding: ${styles.size[4]} ${styles.size[0]};
  text-align: left;
  vertical-align: middle;
`

export const tableRow = css`
  border: none;
`

export const striped = (theme: Theme) => css`
  background: ${theme.palette.background.secondary};
`

export const fontWeightBold = css`
  font-weight: 500;
`

export const clickable = (theme: Theme) => css`
  cursor: pointer;

  &:hover {
    background: ${theme.palette.neutral[100]};
  }
`
